import { $ } from '../vendors/jquery';

class Archive
{
    constructor( element ) 
    {
        this.element    = element;
        this.categories = this.element.find( '[data-element="archive-term"]' );
        this.list       = this.element.find( '[data-element="archive-list"]' );
        this.load       = this.element.find( '[data-element="archive-load"]' );
        this.loader     = this.element.find( '[data-element="archive-loader"]' );
        this.button     = this.element.find( '[data-element="archive-button"]' );
        this.ajax       = mlpAsiaTheme.ajax; // eslint-disable-line

        this.itemHolder  = this.element.data( 'item-holder' );
        this.loadInitial = this.element.data( 'load-initial' );
        this.loadPage    = this.element.data( 'load-page' );
        this.page        = 2;
        this.postType    = this.element.data( 'post-type' );
        this.term        = 0;
        this.taxonomy    = null;
        this.hash        = $( window.location ).prop( 'hash' ).substr( 1 );

        this.init();
    }

    init() 
    {
        this.categories.each( ( index, element ) => {
            $( element ).on( 'click', this.onCategoryClick.bind( this, element ) );
        } );
        this.button.on( 'click', this.onButtonClick.bind( this ) );

        if ( '' !== this.hash ) {
            this.filterCategory();
        }
    }

    onCategoryClick( element ) 
    {
        const $element = $( element );

        if ( $element.hasClass( 'is-active' ) ) {
            return false;
        }

        this.taxonomy = $element.data( 'taxonomy' );
        this.term     = $element.data( 'id' );
        this.page     = 1;
        
        this.setCategoriesInactive();
        $element.addClass( 'is-active' );
        this.clearItems();
        this.showLoad();
        this.loadItems();
    }

    filterCategory() 
    {
        const category = this.element.find( '[data-element="archive-term"][data-slug="' + this.hash + '"]' );

        if ( 0 === category.length ) {
            return;
        }

        this.onCategoryClick( category );
    }

    setCategoriesInactive() 
    {
        this.categories.each( ( index, element ) => {
            $( element ).removeClass( 'is-active' );
        } );
    }

    onButtonClick() 
    {
        this.loadItems();
    }

    loadItems() 
    {
        this.showLoader();

        $.ajax( {
            data: {
                'action': 'archive_load_more',
                'item_holder': this.itemHolder,
                'load_initial': this.loadInitial,
                'load_page': this.loadPage,
                'nonce': this.ajax.nonce,
                'page': this.page,
                'post_type': this.postType,
                'taxonomy': this.taxonomy,
                'term': this.term
            },
            dataType: 'json',
            method: 'POST',
            url: this.ajax.url
        } ).done( (data) => {
            if (null !== data.html) {
                this.list.append( data.html );
            }

            if ( data.hideButton ) {
                this.hideLoad();
            }

            this.page++;
        } ).fail( (jqXHR) => {
            console.log(jqXHR);
        } ).always( () => {
            this.hideLoader();
        } );
    }

    clearItems() 
    {
        this.list.empty();
    }

    hideLoader() 
    {
        this.loader.addClass( 'd-none' );
    }

    showLoader() 
    {
        this.loader.removeClass( 'd-none' );
    }

    hideLoad() 
    {
        this.load.addClass( 'd-none' );
    }

    showLoad() 
    {
        this.load.removeClass( 'd-none' );
    }
}

const archive = {
    init() {
        const archiveElements = $( '[data-module="archive"]' );

        if ( null !== archiveElements && archiveElements.length > 0 ) {
            archiveElements.each( ( index, element ) => {
                new Archive( $( element ) );
            } );
        }
    }
};

export default archive;

$(document).ready(function() {
    // Check if any elements with the class '.tournament-schedule__filter' exist
    if ($('.tournament-schedule__filter').length > 0) {
        // When the 'Upcoming Tournaments' button is clicked
        $('#upcomingButton').click(function() {
            // Add 'active' class to this button and remove from the other
            $(this).addClass('active');
            $('#pastButton').removeClass('active');

            // Change the page location
            window.location.href = '?tournament_filter=upcoming';
        });

        // When the 'Past Tournament Results' button is clicked
        $('#pastButton').click(function() {
            // Add 'active' class to this button and remove from the other
            $(this).addClass('active');
            $('#upcomingButton').removeClass('active');

            // Change the page location
            window.location.href = '?tournament_filter=past';
        });
    }
});
